import fetch from './fetch'

const url = ''
const services = {
  getMobileSms: data => fetch(url + '/app/access/v2/sms', data, false, true),
  appidbyno: data => fetch(url + '/app/auth/application/appidbyno', data),
  v2Login: data => fetch(url + '/app/access/v2/login', data, false, true),
  login: data => fetch(url + '/app/access/login', data),
  loginOut: data => fetch(url + '/app/access/logout', data, true),
  logincode: data => fetch(url + '/app/auth/authcode/logincode', data, true),
  provinceList: data => fetch(url + '/app/base/province/list', data),
  fileUpload: data => fetch(url + '/app/file/upload/public?tlId=frane&catId=company', data),
  cityList: data => fetch(url + '/app/base/city/list', data),
  countyList: data => fetch(url + '/app/base/county/list', data),
  industryList: data => fetch(url + '/app/base/industry/list', data),
  applicationList: data => fetch(url + '/app/auth/application/in/list', data), // 应该列表 post
  authApplication: data => fetch(url + '/app/auth/application/in/application', data), // 保存 post  对象查询 get 删除delete
  userPromote: data => fetch(url + '/app/auth/user/promote', data), // 升级管理员
  userPassword: data => fetch(url + '/app/auth/user/in/password', data), // 修改密码
  userPasswordReset: data => fetch(url + '/app/auth/user/in/password/reset', data), // 重置密码
  currentUser: data => fetch(url + '/app/auth/user/in/user/curr', data), // 获取当前登录用户的信息get 保存当前登录用户的信息post
  userPrivilege: data => fetch(url + '/app/auth/user/in/privilege', data), // 获取用户所有控件
  getRoleList: data => fetch(url + '/app/auth/role/in/list', data), // 获取角色列表
  changeStatus: data => fetch(url + '/app/auth/user/in/status', data), // 用户禁用、启用
  authAccount: data => fetch(url + '/app/auth/user/in/user/account', data, true), // 保存用户时，输入账号查询是否已存在该用户
  getUserList: data => fetch(url + '/app/auth/userInApp/in/list', data),
  authUser: data => fetch(url + '/app/auth/user/in/user', data),
  crmUserBusi: data => fetch(url + '/app/auth/user/in/user/busi', data), // 保存（业务人员，在CRM等平台调用）
  authAdminUser: data => fetch(url + '/app/auth/user/in/user/admin', data), // 保存（公司管理员和应用管理员，在公司管理中心调用）
  getApplication: data => fetch(url + '/app/auth/userApplication/in/application', data), // 5获得当前登录用户拥有的应用 参数 "type": 1 //类型。1：系统类，2：业务类。可以为null
  getMenuTree: data => fetch(url + '/app/auth/menu/in/menuTree', data),
  getUserMenuTree: data => fetch(url + '/app/auth/menu/in/userMenuTree', data),
  menuPosition: data => fetch(url + '/app/auth/menu/in/position', data),
  authMenu: data => fetch(url + '/app/auth/menu/in/menu', data), // 菜单管理 获取菜单get 编辑菜单post
  authRoleList: data => fetch(url + '/app/auth/role/in/list', data),
  authRole: data => fetch(url + '/app/auth/role/in/role', data),
  authFormList: data => fetch(url + '/app/auth/form/in/list', data),
  authForm: data => fetch(url + '/app/auth/form/in/form', data),
  authComponentList: data => fetch(url + '/app/auth/component/in/list', data),
  authComponent: data => fetch(url + '/app/auth/component/in/component', data),
  roleMenuMenuList: data => fetch(url + '/app/auth/roleMenu/in/menuList', data), // 查询角色拥有的菜单
  roleMenu: data => fetch(url + '/app/auth/roleMenu/in/roleMenu', data), // 保存角色与菜单关系
  menuComponent: data => fetch(url + '/app/auth/component/in/menuComponent', data), // 获取菜单所有权限列表
  roleCompList: data => fetch(url + '/app/auth/roleComp/in/roleCompList', data), // 获取角色所有的控件权限
  roleComp: data => fetch(url + '/app/auth/roleComp/in/roleComp', data), // 保存角色与控件关系
  appRole: data => fetch(url + '/app/auth/userRole/in/appRole', data), // 查询当前登录用户在该应用的角色
  authOrgTree: data => fetch(url + '/app/auth/org/in/orgTree', data), // 获取部门树
  authOrg: data => fetch(url + '/app/auth/org/in/org', data), // 部门
  authOrgPosition: data => fetch(url + '/app/auth/org/in/position', data), // 拖动修改部门位置
  noOrgUser: data => fetch(url + '/app/auth/user/in/noOrgUser', data), // 获得在该应用下没有部门的用户
  synchronizeOrg: data => fetch(url + '/app/auth/entWeixin/in/synchronize/org', data), // 企业微信部门同步 get /appId
  synchronizeUser: data => fetch(url + '/app/auth/entWeixin/in/synchronize/user', data), // 企业微信用户同步 post {appId, systemType} //系统类型，1：内部，2：外部
  failureUser: data => fetch(url + '/app/auth/entWeixin/in/failure/user', data), //  同步用户下载失败
  failureOrg: data => fetch(url + '/app/auth/entWeixin/in/failure/org', data), //  同步部门下载失败
  entityList: data => fetch(url + '/app/auth/entity/page', data), // 公司列表
  entity: data => fetch(url + '/app/auth/entity', data), // 公司对象列表
  entityObj: data => fetch(url + '/app/auth/entity/obj', data), // 保存（售电公司、能源服务商）
  entityapplicationList: data => fetch(url + '/app/auth/entityapplication/list', data), // 查询企业与应用的关系
  entityapplicationObj: data => fetch(url + '/app/auth/entityapplication/obj', data), // 保存企业与应用的关系
  businessList: data => fetch(url + '/app/base/dictionary/in/businessList', data), // 数据字典业务列表
  dictionaryList: data => fetch(url + '/app/base/dictionary/in/list', data), // 数据字典列表
  dictionary: data => fetch(url + '/app/base/dictionary/in/dictionary', data), // 数据字典对象查询 新增编辑 数据字典 删除
  datapermList: data => fetch(url + '/app/auth/dataperm/list', data), // 数据权限列表
  dataperm: data => fetch(url + '/app/auth/dataperm', data), // 数据权限对象获取和删除
  datapermObj: data => fetch(url + '/app/auth/dataperm/obj', data), // 数据权限对象保存
  roledatapermList: data => fetch(url + '/app/auth/roledataperm/list', data), // 获取角色与数据权限关系
  roledatapermObj: data => fetch(url + '/app/auth/roledataperm/obj', data), // 保存角色与数据权限关系
  feignDataperm: data => fetch(url + '/app/auth/feign/dataperm/roleperm', data), // 获取当前用户的数据权限配置
  loginpageappPage: data => fetch(url + '/app/auth/loginpageapp/page', data), // 登录页面配置列表查询
  loginpage: data => fetch(url + '/app/auth/loginpage', data), // get 登录页面配置对象查询 delete 登录页面配置对象删除
  loginpageObj: data => fetch(url + '/app/auth/loginpage/obj', data), // 登录页面配置对象保存
  deleterediskey: data => fetch(url + '/app/auth/cache/deleterediskey', data), // 清除缓存
  loginpageOut: data => fetch(url + '/app/auth/loginpage/out', data), // 页面配置查询（不需要登录）
  getLoadforecast: data => fetch(url + '/app/auth/feign/entityapp/loadforecast', data), // 获取企业的负荷预测配置
  redirectlogin: data => fetch(url + '/app/auth/user/redirectlogin', data), // 外部系统访问
  userimport: data => fetch(url + '/app/auth/user/imp/busiuser', data), // 导入业务用户
  userimportTemp: data => fetch(url + '/app/auth/file/download', data), // 下载导入业务用户模板
  homeSchemeList: (id, data) => fetch(url + `/app/auth/indexscheme/list/${id}`, data), // 首页方案列表
  homeSchemeNewly: data => fetch(url + '/app/auth/indexscheme/obj', data), // 首页方案新增/编辑
  homeSchemeDelete: (id, data) => fetch(url + `/app/auth/indexscheme/${id}`, data), // 首页方案删除
  homeSchemeId: (id, data) => fetch(url + `/app/auth/indexscheme/role/${id}`, data), // 获取角色的首页方案ID
  getAppPackages: (data) => fetch(url + `/app/auth/application/in/selectlist`, data), // 查询应用与套餐列表（不分页）
  getAppDetail: (id, data) => fetch(url + `/app/auth/application/in/application/${id}`, data), // 查询应用详情
  getPackageDetail: (id, data) => fetch(url + `/app/auth/meal/obj?id=${id}`, data, false, true), // 查询详细信息
  savePackage: (data) => fetch(url + `/app/auth/meal/save`, data, false, true), // 保存套餐
  deletePackage: (id, data) => fetch(url + `/app/auth/meal/obj?id=${id}`, data, false, true), // 删除套餐
  getAppLists: (data) => fetch(url + '/app/auth/appmeal/list', data, false, true), // 应用套餐信息分页查询
  getPackagesList: (data) => fetch(url + '/app/auth/meal/list', data, false, true), // 套餐信息不分页查询
  saveAppPackage: (data) => fetch(url + '/app/auth/appmeal/save', data, false, true), // 开通应用套餐保存
  getAppPackageDetail: (id, data) => fetch(url + `/app/auth/appmeal/obj?id=${id}`, data, false, true), // 查询详细信息
  deleteAppPackage: (id, data) => fetch(url + `/app/auth/appmeal/obj?id=${id}`, data, false, true), // 应用详情--删除
  upgradeUserToAdmin: (data) => fetch(url + '/app/auth/user/promote/upgrade', data), // 用户管理–升级管理员
  getMenuTreeForRoles: (data) => fetch(url + '/app/auth/menu/in/meal/menuTree', data), // 获取某个企业的整个菜单树（套餐菜单交集）
  exportMenu: (data) => fetch(url + '/app/auth/menu/in/menu/export', data), // 菜单导出
  downloadMenu: (data) => fetch(url + '/app/auth/menu/getmenutemp', data), // 菜单导入模板下载
  importMenu: (data) => fetch(url + '/app/auth/menu/import', data, false, true), // 菜单导入
  cationlist: (data) => fetch(url + '/app/auth/cloudauthorization/getremoteapplicationlist', data, false, true), // 获取云菜单
  getAppToken: (data) => fetch(url + '/app/auth/frmOauth/token', data, false, true), // 获取即将跳转应用的token

  // ----------------新密码修改校验功能  START--------------------------
  sendNewPasswordSms: (data) => fetch(url + '/app/auth/sms/send', {...data, method: 'get'}), // 强制修改密码功能的 - 发送验证码

  saveNewPassword: (data) => fetch(url + '/app/auth/user/in/password/bysms', data) // 保存新密码

  // ----------------新密码修改校验功能  END--------------------------
}

export default services



// WEBPACK FOOTER //
// ./src/fetch/index.js